import React from "react";
import { Card } from "@/components/ui/card";
import { AlertTriangle, CheckCircle } from "lucide-react";
import { formatCurrency } from "./constants";

export const TransactionStatsCards = ({ activeCount, totals, mismatchCount }) => (
  <div className="grid grid-cols-4 gap-4 mb-6">
    <Card className="p-4" data-testid="stat-active-transactions">
      <p className="text-xs text-slate-500 uppercase">Active Transactions</p>
      <p className="text-2xl font-mono font-semibold">{activeCount}</p>
    </Card>
    <Card className="p-4" data-testid="stat-total-amount">
      <p className="text-xs text-slate-500 uppercase">Total Amount</p>
      <p className="text-2xl font-mono font-semibold">{formatCurrency(totals.amount)}</p>
    </Card>
    <Card className="p-4" data-testid="stat-total-tds">
      <p className="text-xs text-slate-500 uppercase">Total TDS</p>
      <p className="text-2xl font-mono font-semibold text-emerald-600">{formatCurrency(totals.tds)}</p>
    </Card>
    <Card className={`p-4 ${mismatchCount > 0 ? "border-amber-300 bg-amber-50" : ""}`} data-testid="stat-mismatches">
      <p className="text-xs text-slate-500 uppercase">Rate Mismatches</p>
      <p className={`text-2xl font-mono font-semibold ${mismatchCount > 0 ? "text-amber-600" : "text-green-600"}`}>
        {mismatchCount > 0 ? (
          <AlertTriangle className="inline w-5 h-5 mr-1" />
        ) : (
          <CheckCircle className="inline w-5 h-5 mr-1" />
        )}
        {mismatchCount}
      </p>
    </Card>
  </div>
);
